import React from "react";

export const TerminateModal = ({onDelete, isLoading }) => {
	return (
		<div className="modal fade px-0" id="terminateDeclaration" aria-labelledby="terminateDeclarationLabel" aria-hidden="true">
			<div className="modal-dialog px-2">
				<div className="modal-content">
					<div className="modal-header">
						<div className="alert bg-alert-primary rounded-bottom-right-sm rounded-top-left-sm w-100 text-center mb-0">
							<h1 className="sr-only visually-hidden">Clôturer</h1>
							<div className="flex-row align-items-center justify-content-between">
								<div className="h4 font-weight-demi  text-uppercase mb-0 ls-n1 lh-1 mx-auto" id="terminateDeclarationLabel">
									Clôturer dossier de déménagement
								</div>
								<button type="button" className="btn btn-close btn-icon p-0 mr-0" data-dismiss="modal" aria-label="Close">
									<i className="eva eva-close fs-4"></i>
								</button>
							</div>
						</div>
					</div>
					<div className="modal-body text-center">
						<div className="fs-sm ls-n1">
							Etes-vous sûr(e) de vouloir clôturer le <strong>dossier de déménagement</strong>?
						</div>
						<p className="fs-3 o-60">Une fois le dossier clôturé, les courriers ne seront plus accessibles. Confirmez que vous avez téléchargé tous les courriers dont vous avez besoin.</p>
					</div>
					<div className="modal-footer justify-content-center">
						<button type="button" className="btn btn-faded" data-dismiss="modal" aria-label="Close">
							Annuler
						</button>
						{isLoading ? (
							<button type="button" className="btn btn-danger loading-btn px-md-gutter px-4 show">
								Clôturer<div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div>
							</button>
						) : (
							<button type="button" className="btn btn-danger" onClick={onDelete}>
								Clôturer
							</button>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};
